export default __webpack_public_path__ + "static/media/scan.1a5227f7.gif";